module.exports = __webpack_public_path__ + "static/media/featureimage1.618441de.jpg";